import { Typography } from "@trustpilot/constellation-components";
import { Text, useTranslations } from "ilenia";
import React from "react";
import { useHistory } from "react-router-dom";

import { TierInfo, TrialInfo, StartTrialInfo } from ".";
import { trackingConst } from "../../../../constants";
import { useAnalytics } from "../../../../utils/analytics";
import { StyledButton, StyledTier, StyledTierOuter } from "../../styled";
import * as Types from "../../types/types";

const PlanInfo: React.FC<Types.PlanInfo> = ({ tier, trial, eligibility, autoRenew, setShowFreeTrialModal }) => {
  const analytics = useAnalytics();
  const history = useHistory();
  const [translations] = useTranslations();

  const onClick = (e: React.MouseEvent) => {
    e.preventDefault();
    analytics.track(trackingConst.events.upgradeLinkClick, {
      UpgradeSource: trackingConst.names.menuLeftSidebar,
      context: trackingConst.contexts.sidebar,
    });
    history.push("/upgrade?upgradeSource=MenuLeftSidebar");
  };

  const showTierInfo = trial && trial?.planName !== "" ? false : !!tier;
  const hasProductLedTrial = trial?.hasTrial && !trial?.isLegacy;
  const isOnCancelledProductLedTrial = hasProductLedTrial && trial?.trialState === "TrialCancelled";
  const isOnActiveProductLedTrial = hasProductLedTrial && trial?.trialState === "TrialActive";
  const showUpgradeButton = !isOnActiveProductLedTrial && !tier?.name?.toLowerCase().includes("enterprise");
  const isEligibleForTrial =
    eligibility?.trial?.isEligible &&
    eligibility?.trial?.eligibleBusinessModules.find((module) => module?.key === "Plus");

  return isEligibleForTrial ? (
    <StartTrialInfo eligibility={eligibility} setShowFreeTrialModal={setShowFreeTrialModal} />
  ) : (
    <StyledTierOuter>
      {trial?.hasTrial && <TrialInfo trial={trial} isOnCancelledProductLedTrial={isOnCancelledProductLedTrial} />}
      {showTierInfo && <TierInfo tier={tier} autoRenew={autoRenew} />}
      {showUpgradeButton && (
        <StyledTier className="upgrade-button">
          <StyledButton
            wide={isOnCancelledProductLedTrial}
            appearance="positive"
            size="s"
            onClick={(e: React.MouseEvent) => onClick(e)}
            ariaLabel={translations["Sidebar.upgrade.ariaLabel"]}
            as="a"
            href={`/upgrade?upgradeSource=MenuLeftSidebar`}
          >
            <Typography variant="heading-xxs" as="span">
              <Text id="Sidebar.upgrade.button" />
            </Typography>
          </StyledButton>
        </StyledTier>
      )}
    </StyledTierOuter>
  );
};

export default PlanInfo;
